import { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { fmtDateTime } from './orderConstants';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LABELS = {
  created: 'Dossier créé', status_changed: 'Changement de statut',
  file_uploaded: 'Fichier déposé', file_downloaded: 'Fichier téléchargé',
  assigned: 'Affecté au laboratoire', work_order_generated: 'Bon de travail généré',
  message_sent: 'Message envoyé', message_hidden: 'Message masqué',
  certificate_submitted: 'Certificat de conformité déposé',
  client_invoice_created: 'Facture client générée', patient_updated: 'Patient mis à jour',
};

export const TimelineCard = ({ orderId }) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    axios.get(`${API}/orders/${orderId}/events`).then((r) => setEvents(r.data)).catch(() => {});
  }, [orderId]);

  if (!events.length) return null;
  return (
    <Card className="border-border" data-testid="order-timeline">
      <CardHeader><CardTitle className="text-base">Chronologie complète ({events.length})</CardTitle></CardHeader>
      <CardContent>
        <ul className="space-y-0">
          {events.map((e) => (
            <li key={e.id} className="relative pl-5 pb-3 border-l border-border last:pb-0 ml-1">
              <span className="absolute -left-[5px] top-1 h-2.5 w-2.5 rounded-full bg-primary/60" />
              <p className="text-sm font-medium">{LABELS[e.event_type] || e.event_type}</p>
              <p className="text-xs text-muted-foreground">
                {e.actor_name || 'Système'} ({e.actor_role || 'auto'}) · {fmtDateTime(e.created_at)}
                {e.details?.from && ` · ${e.details.from} → ${e.details.to}${e.details.auto ? ' (auto)' : ''}`}
                {e.details?.file && ` · ${e.details.file}`}
                {e.details?.invoice_number && ` · ${e.details.invoice_number}`}
              </p>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
